import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeDetailsStyles } from 'styles/pages/product';
import { Typography } from '@material-ui/core';
import { CODES } from 'views/pages/Product/common/constants';
import Table from './Table';

type Props = {
    data: Array<{
        code: string;
        name: string;
        value: string;
    }>;
};

const Details: React.FC<Props> = ({ data }) => {
    const {
        BOOK_ISBN,
        BOOK_PAGES,
        BOOK_SERIES,
        BOOK_TYPES,
        PRODUCT_TYPE,
        SCHOOL_LEVEL,
        SCHOOL_SUBJECTS,
    } = CODES;

    const firstTableCodes: Array<string> = [
        BOOK_SERIES,
        SCHOOL_SUBJECTS,
        SCHOOL_LEVEL,
        PRODUCT_TYPE,
    ];
    const secondTableCodes: Array<string> = [BOOK_TYPES, BOOK_ISBN, BOOK_PAGES];

    const { paragraph, wrapper } = makeDetailsStyles();

    return data.length ? (
        <Box className={wrapper}>
            <Typography className={paragraph} paragraph>
                Szczegóły
            </Typography>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={10} md={9} lg={6}>
                    <Table codes={firstTableCodes} data={data} />
                </Grid>
                <Grid item xs={12} sm={10} md={9} lg={6}>
                    <Table codes={secondTableCodes} data={data} />
                </Grid>
            </Grid>
        </Box>
    ) : null;
};

export default Details;
